import clsx from 'clsx'
import { useRouter } from 'next/router'

import { PlanType, useGetUserQuery } from '~/graphql/generated/schema'
import { useCommonTx } from '~/hooks/useTranslationForNamespace'
import Checkmark from '~/images/Assessment/CheckMarkSharp.svg'
import FlyBirdCircle from '~/images/home/FlyBirdCircle.svg'

export const FamilyChallengeComingSoon = ({ className }: { className?: string }) => {
  const router = useRouter()
  const t = useCommonTx('upcomingFeatures.familyChallenge')
  const ct = useCommonTx('common')

  const { data } = useGetUserQuery()

  const subscription = data?.me?.subscription

  const isFamilyPlan = subscription?.__typename === 'LumosSubscription' && subscription.planType === PlanType.Family
  const isDependentPlan = subscription?.__typename === 'DependentSubscription'

  const showCard = isFamilyPlan || isDependentPlan

  const onManageSeats = () => {
    router.push('/family-management')
  }

  if (!showCard) return null

  return (
    <div className={clsx('flex flex-col', className)}>
      <div className='text-subheading-1 mb-4'>{t('head')}</div>
      <div className='flex flex-col shadow-drop-shadow-3 rounded-lg bg-surface-default'>
        <div className='py-5 px-6 flex flex-row gap-5'>
          <div className='w-[62px] h-[62px] flex justify-center items-center'>
            <FlyBirdCircle title='f' className='w-[62px] h-[62px]' />
          </div>
          <div className='flex flex-col gap-2'>
            <div className='text-subheading-2 mb-1'>{t('title')}</div>
            <div className='text-body-text-3 text-text-subdued mb-1'>{t('desc')}</div>
            <div className='flex flex-row flex-wrap gap-5 text-caption-1 font-semibold text-text-subdued'>
              {[ct('yourDataSafe'), ct('featureComingSoon')].map((item) => {
                return (
                  <div key={item} className='flex flex-row gap-1 items-center'>
                    <div className='w-[13px] h-[13px] bg-success-50 rounded-full flex justify-center items-center'>
                      <Checkmark title='f' className='w-[7px] h-[7px] text-white' />
                    </div>
                    {item}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        {isFamilyPlan && (
          <div className='bg-neutral-cool-98 border-t border-border-subdued py-5 px-6 flex flex-row flex-wrap justify-between gap-2'>
            <div className='flex flex-row gap-1 items-center justify-center'>
              <span className='text-subheading-3'>{ct('yourFamilyPlan')}</span>
              <span className='text-body-text-3'>
                {ct('seatsFilled', {
                  filled: (subscription.dependentUsers || []).length,
                  total: subscription.maximumDependents ?? 0,
                })}
              </span>
            </div>
            <button className='text-text-interactive underline p-0' onClick={onManageSeats}>
              {ct('manageSeats')}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
